/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
import { BOProduct } from '@boels/models';
import { createAction, props } from '@ngrx/store';

export const GET_PRODUCT = '[Product] get Product Data';
export const LOAD_PRODUCT = '[Product] Load Product Data';
export const LOAD_PRODUCT_FAIL = '[Product] Load Product Data Fail';
export const LOAD_PRODUCT_SUCCESS = '[Product] Load Product Data Success';

export const getProduct = createAction(
  GET_PRODUCT,
  props<{
    productCode: string;
    culture: string;
  }>(),
);

export const loadProduct = createAction(
  LOAD_PRODUCT,
  props<{
    productCode: string;
    culture: string;
  }>(),
);

export const loadProductFail = createAction(
  LOAD_PRODUCT_FAIL,
  props<{ errorMessage: string }>(),
);

export const loadProductSuccess = createAction(
  LOAD_PRODUCT_SUCCESS,
  props<{
    product: BOProduct;
    culture: string;
  }>(),
);
